import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import Footer from "examples/Footer";
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import MessagingHub from "../ContentHub/MessagingHub";
import Icon from "@mui/material/Icon";
import { useState } from "react";

function MessagingPage() {
  // Mocked state (can be replaced with real API logic)
  const [linkedInMessages, setLinkedInMessages] = useState([
    {
      id: "li-1",
      participant: "Jane Doe",
      lastMessageSnippet: "Hi, can you send the report?",
      messages: [
        { sender: "Jane Doe", text: "Hi, can you send the report?" },
        { sender: "You", text: "Sure, sending now!" },
      ],
    },
  ]);
  const [instagramMessages, setInstagramMessages] = useState([
    {
      id: "ig-1",
      participant: "@instauser",
      lastMessageSnippet: "Thanks for the update!",
      messages: [
        { sender: "@instauser", text: "Thanks for the update!" },
        { sender: "You", text: "You're welcome!" },
      ],
    },
  ]);
  const [messagesLoading, setMessagesLoading] = useState(false);
  const [messagesError, setMessagesError] = useState(null);

  const handleReply = (platform, threadId, replyText) => {
    if (platform === "linkedin") {
      setLinkedInMessages((prev) =>
        prev.map((thread) =>
          thread.id === threadId
            ? {
                ...thread,
                messages: [...thread.messages, { sender: "You", text: replyText }],
                lastMessageSnippet: replyText,
              }
            : thread
        )
      );
    } else if (platform === "instagram") {
      setInstagramMessages((prev) =>
        prev.map((thread) =>
          thread.id === threadId
            ? {
                ...thread,
                messages: [...thread.messages, { sender: "You", text: replyText }],
                lastMessageSnippet: replyText,
              }
            : thread
        )
      );
    }
    // Here, you would call the real API to send the message
  };

  return (
    <DashboardLayout>
      <DashboardNavbar />
      <MDBox
        py={3}
        sx={{
          height: "calc(100vh - 64px)",
          overflowY: "auto",
          overflowX: "hidden",
        }}
      >
        <MDBox mb={3} display="flex" alignItems="center" gap={1.5}>
          <MDBox
            sx={{
              width: 40,
              height: 40,
              borderRadius: "12px",
              background: "linear-gradient(135deg, #1A73E8 0%, #0D47A1 100%)",
              display: { xs: "none", sm: "flex" },
              alignItems: "center",
              justifyContent: "center",
              boxShadow: "0 4px 14px rgba(26, 115, 232, 0.3)",
            }}
          >
            <Icon sx={{ color: "white", fontSize: "1.3rem !important" }}>chat</Icon>
          </MDBox>
          <MDTypography
            variant="h3"
            fontWeight="bold"
            sx={{ fontSize: { xs: "1.5rem", sm: "1.75rem", md: "2rem" }, color: "#1a1a2e" }}
          >
            Messaging
          </MDTypography>
        </MDBox>
        <MDTypography
          variant="body2"
          sx={{
            fontSize: { xs: "0.8rem", sm: "0.875rem" },
            color: "#6B7280",
            pl: { xs: 0, sm: 7 },
          }}
        >
          View and reply to your social platform messages in one place
        </MDTypography>
        <MDBox mt={4}>
          <MessagingHub
            linkedInMessages={linkedInMessages}
            instagramMessages={instagramMessages}
            onReply={handleReply}
            loading={messagesLoading}
            error={messagesError}
          />
        </MDBox>
      </MDBox>
      <Footer />
    </DashboardLayout>
  );
}

export default MessagingPage;
